var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "oppdater",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.722 1.1455C10.722 1.1455 10.0595 1.792 9.6005 2.246C7.257 0.534004 3.9545 0.728004 1.838 2.8445C0.602999 4.0795 0.026499 5.718 0.095999 7.336H2.096C2.0255 6.23 2.405 5.1025 3.25 4.257C4.5815 2.9255 6.6175 2.7355 8.156 3.676C7.635 4.192 7.0335 4.795 7.0335 4.795C6.613 5.2995 7.0855 5.591 7.3255 5.5835L10.1375 5.583C10.286 5.583 10.407 5.5835 10.407 5.5835C10.407 5.5835 10.5295 5.5835 10.6785 5.5835H11.2245C11.3735 5.5835 11.4945 5.462 11.4945 5.313V1.4475C11.5115 1.094 11.1235 0.751003 10.722 1.1455Z",
    fill: "#016CC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27749 12.8545C1.27749 12.8545 1.94049 12.208 2.39899 11.754C4.74299 13.466 8.04499 13.272 10.162 11.1555C11.397 9.92 11.973 8.282 11.904 6.664H9.90349C9.97449 7.7695 9.59499 8.8975 8.74949 9.7435C7.41799 11.0745 5.38199 11.265 3.84349 10.324C4.36449 9.808 4.96599 9.205 4.96599 9.205C5.38649 8.7 4.91399 8.409 4.67399 8.4165L1.86199 8.4175C1.71349 8.4175 1.59199 8.4165 1.59199 8.4165C1.59199 8.4165 1.46949 8.4165 1.32049 8.4165H0.775494C0.626494 8.4165 0.505494 8.5375 0.504994 8.687V12.553C0.488494 12.906 0.876494 13.249 1.27749 12.8545Z",
    fill: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.66840360.svg";
export { ForwardRef as ReactComponent };